@if (taxationLiability$ | async; as taxationLiability) {
    <div class="quick-bet-action-button__taxation-liability">
        <bs-betslip-taxation-liability [taxBackGiven]="taxationLiability" />
    </div>
}
